const pictureUrl =
  'data:image/jpeg;base64,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';

export const studentsData = {
  page: 1,
  size: 20,
  total: 13,
  items: [
    {
      id: 'id1',
      number: 2,
      displayName: 'Student Name 1',
      state: 'ACTIVE',
      email: 'studentEmail1@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id2',
      number: 22,
      displayName: 'Student Name 2',
      state: 'ACTIVE',
      email: 'studentEmail2@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id3',
      number: 221,
      displayName: 'Student Name 3',
      state: 'ACTIVE',
      email: 'studentEmail3@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id4',
      number: 22,
      displayName: 'Student Name 4',
      state: 'ACTIVE',
      email: 'studentEmail4@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id5',
      number: 22,
      displayName: 'Student Name 5',
      state: 'ACTIVE',
      email: 'studentEmail5@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id6',
      number: 22,
      displayName: 'Student Name 6',
      state: 'ACTIVE',
      email: 'studentEmail6@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id7',
      number: 22,
      displayName: 'Student Name 7',
      state: 'ACTIVE',
      email: 'studentEmail7@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id8',
      number: 22,
      displayName: 'Student Name 8',
      state: 'ACTIVE',
      email: 'studentEmail8@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id9',
      number: 22,
      displayName: 'Student Name 9',
      state: 'ACTIVE',
      email: 'studentEmail9@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id21',
      number: 22,
      displayName: 'Student Name 10',
      state: 'ACTIVE',
      email: 'studentEmail10@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id22',
      number: 22,
      displayName: 'Student Name 11',
      state: 'ACTIVE',
      email: 'studentEmail11@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id24',
      number: 22,
      displayName: 'Student Name 12',
      state: 'ACTIVE',
      email: 'studentEmail12@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
    {
      id: 'id25',
      number: 22,
      displayName: 'Student Name 13',
      state: 'ACTIVE',
      email: 'studentEmail13@taltech.ee',
      role: 'STUDENT',
      owner: [
        {
          id: 'idl1',
          displayName: 'lect1',
          description: 'Blabla',
        },
      ],
      createdDate: new Date(Date.now()),
    },
  ],
};
